import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { SignalRService, DeploymentBulletinEvent } from '../../services/signalr.service';

@Component({
    selector: 'app-deployment-bulletin',
    templateUrl: './deployment-bulletin.component.html',
    styleUrls: ['./deployment-bulletin.component.css'],
    standalone: false
})
export class DeploymentBulletinComponent implements OnInit, OnDestroy {
  visible = false;
  message = '';
  sentBy = '';
  totalSeconds = 0;
  remainingSeconds = 0;
  timestamp: Date | null = null;

  private bulletinSub?: Subscription;
  private countdownSub?: Subscription;

  constructor(private signalRService: SignalRService) {}

  ngOnInit(): void {
    this.bulletinSub = this.signalRService.onDeploymentBulletin.subscribe(
      (event: DeploymentBulletinEvent | null) => {
        if (event) {
          this.showBulletin(event);
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.bulletinSub?.unsubscribe();
    this.countdownSub?.unsubscribe();
  }

  private showBulletin(event: DeploymentBulletinEvent): void {
    this.message = event.message;
    this.sentBy = event.sentBy;
    this.totalSeconds = event.countdownSeconds;
    this.remainingSeconds = event.countdownSeconds;
    this.timestamp = new Date(event.timestamp);
    this.visible = true;

    // Stop any existing countdown
    this.countdownSub?.unsubscribe();

    // Start countdown
    this.countdownSub = interval(1000).subscribe(() => {
      this.remainingSeconds--;
      if (this.remainingSeconds <= 0) {
        this.remainingSeconds = 0;
        this.countdownSub?.unsubscribe();
      }
    });
  }

  get minutes(): string {
    return Math.floor(this.remainingSeconds / 60).toString().padStart(2, '0');
  }

  get seconds(): string {
    return (this.remainingSeconds % 60).toString().padStart(2, '0');
  }

  get progressPercent(): number {
    if (this.totalSeconds === 0) return 0;
    return ((this.totalSeconds - this.remainingSeconds) / this.totalSeconds) * 100;
  }

  get isUrgent(): boolean {
    return this.remainingSeconds <= 60;
  }

  get isCritical(): boolean {
    return this.remainingSeconds <= 0;
  }

  dismiss(): void {
    this.visible = false;
    this.countdownSub?.unsubscribe();
  }
}
